export const CORRECT = 'Correct'
export const INCORRECT = 'Incorrect'
